import {Injectable} from "@angular/core";
import {LogoutUseCase} from "@app/core/user/application/logout.use-case";
import {IsLoggedInUseCase} from "@app/core/user/application/isLoggedIn.use-case";
import {firstValueFrom} from "rxjs";
import {UserRemote} from "@app/core/user/domain/user.remote";
import {UserLocal} from "@app/core/user/domain/user.local";
import {
    UpdateSelectedDeliveryPointUseCase
} from "@app/core/delivery-point/application/update-selected-delivery-point.use-case";
import {CartLineRepository} from "@app/core/cart/application/cart-line-repository.service";
import {AppOpenedWithProductsInCartEvent} from "@app/core/tracking/application/events/app-opened-with-products-in-cart-event";
import {TrackEventUseCase} from "@app/core/tracking/application/track-event-use-case";

/**
 * Use case for when the application starts, setting up all the necessary tasks at app launch.
 */
@Injectable({
    providedIn: "root"
})
export class InitializeAppUseCase {

    constructor(
        private userLocal: UserLocal,
        private logoutUseCase: LogoutUseCase,
        private isLoggedInUseCase: IsLoggedInUseCase,
        private userRemote: UserRemote,
        private updateSelectedDeliveryPointUseCase: UpdateSelectedDeliveryPointUseCase,
        private cartLineRepository: CartLineRepository,
        private trackEventUseCase: TrackEventUseCase,
    ) {}

    async execute(): Promise<void> {
        const isLoggedIn = await firstValueFrom(this.isLoggedInUseCase.execute());
        if (isLoggedIn) {
            const cartLines = await firstValueFrom(this.cartLineRepository.getCartLines());
            if (cartLines.length > 0) {
                this.trackEventUseCase.execute(new AppOpenedWithProductsInCartEvent());
            }
            await firstValueFrom(this.updateSelectedDeliveryPointUseCase.execute());
            return this.updateSavedUser();
        }
        await firstValueFrom(this.logoutUseCase.execute());
    }

    private async updateSavedUser(): Promise<void> {
        const user = await firstValueFrom(this.userRemote.getUser());
        if (user == null) {
            return;
        }
        this.userLocal.saveUser(user);
    }
}
